module.exports = __webpack_public_path__ + "img/video-zichan.954bcdcd.jpg";